export default "assets/example-5.b38ad488338235f2.gif"